import React from 'react';
import '../css/OkasBoxes.css';
// import Icon from 'react-icons-kit';
// import { iosPlusEmpty } from 'react-icons-kit/ionicons';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import OkasBoxesView from './OkasBoxesView';
import OkasBoxesEdit from './OkasBoxesEdit';
import MemberLicenseAddNew from './MemberLicenseAddNew';
// import nanoid from 'nanoid';
import Sorting from './Sorting';
// import SearchBar from 'material-ui-search-bar';
import SearchBar from './SearchBar';
// import SearchBarNew from './SearchBar'; 
import * as ActionTypes from '../actions/types';
import { connect } from 'react-redux';
// import {  OverlayTrigger, Overlay } from 'react-bootstrap';
import Tooltip from '@mui/material/Tooltip';

// import { calculator } from 'react-icons-kit/ionicons';
// import { Hidden, TablePagination } from '@material-ui/core';
// import edit from './../assets/images/edit.svg';
// import view from './../assets/images/view.svg';
import deleteIcon from './../assets/images/delete.svg';
// import Pagination from 'react-bootstrap/Pagination'
import Loader from './Loader';
import SnackBar from './SnackBar';
import { is_allowed } from '../utilitis';

//okasboxes dashboard page
const customStylesDelete = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
    backgroundColor: '#EFF3F6'
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
    // flexWrap: 'wrap',
  },
  formControl: {
    // margin: theme.spacing.unit,
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
  },
});



class MemberLicense extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalIsOpenAddOB: false,
      modalIsOpenAddOBView: false,
      modalIsOpenAddOBEdit: false,
      modalIsOpenDeleteSuccess: false,
      noOfParams: [],
      mlData: [],
      siData: [],
      actualData: [],
      searchValue: '',
      assinedBoxesSI: 0,
      assinedBoxesProjects: 0,
      unAssinedBoxes: 0,
      MemberLicenseID: '',
      someState: setTimeout(() => {
        if (this.props.redux.auth.searchBarShow) {
          return 'true'
        } else {
          return 'false'
        }
      }, 500),
      sortingStatus: {
        sortingName: '',
        defaultDown: true
      },
      //states for pagination in table
      paginationTable: {
        currentPage: 0,
        pageNeighbours: 2,
        recordPerPage: 10,
        totalRecords: 0,
        recordFirstID: 0,
        recordLastID: 0,
        buttonArray: []
      },

      loader: true,
      snackbarActive: false,
      snackbarMessage: ''

    };
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
  }

  openModal() {
    this.setState({
      modalIsOpenAddOB: false
    }, () => {
      this.setState({
        modalIsOpenAddOB: true
      })
    })
  }



  afterOpenModal() {
    // references are now sync'd and can be accessed.
    // this.subtitle.style.color = '#f00';
  }

  closeModal() {
    this.setState({ modalIsOpenAddOB: false });
  }

  closeModalDelete() {
    this.setState({
      modalIsOpenDelete: false
    });
  }


  ActivateMLModel = (e) => {
    if (this.state.modalIsOpenAddOB) {
      return <MemberLicenseAddNew activeModal={true} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  refreshDevices = (e) => {
    this.setState({
      modalIsOpenAddOB: false,
      modalIsOpenAddOBView: false,
      modalIsOpenAddOBEdit: false,
      modalIsOpenDeleteSuccess: false,
    }, () => {
      this.fetchLicense();
    })
  }

  //function for pagination

  paginationFunction = () => {
    let totalButton = (this.state.mlData.length / this.state.paginationTable.recordPerPage);
    let emtyArray = Array.apply(null, { length: Math.ceil(totalButton) }).map(Number.call, Number)
    this.setState({
      paginationTable: {
        ...this.state.paginationTable,
        buttonArray: emtyArray
      }
    })
  }

  ActivateObModelView = (e) => {
    if (this.state.modalIsOpenAddOBView) {
      return <OkasBoxesView activeModal={true} ObCurrentData={this.state.ObCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  ActivateObModelEdit = (e) => {
    if (this.state.modalIsOpenAddOBEdit) {
      return <OkasBoxesEdit activeModal={true} ObCurrentData={this.state.ObCurrentData} refreshDevices={this.refreshDevices.bind(this)} />
    } else {
      return null
    }
  }

  componentDidMount() {
    this.fetchLicense();
    this.resetSearchBar()
  }


  onDeleteFinal = (e) => {
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    fetch(`/cloud/memberLicense_DetailApi/${this.state.itemToDeleteId}`, {
      method: "DELETE",
      headers: headers,
      body: JSON.stringify({ hello: "hello" })
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        if (data.message === 'success') {
          this.setState({
            modalIsOpenDelete: false,
            modalIsOpenDeleteSuccess: true
          }, () => {
            this.fetchLicense()
          })
        } else {
          this.setState({
            snackbarActive: true,
            snackbarMessage: data.message
          })
          //  alert(data.message)
        }
      })
      .catch((err) => {
        console.log(err)
      })
  }

  fetchLicense = () => {
    this.setState({
      loader: true
    })
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`;
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }
    fetch('/cloud/memberLicenseApi/', {
      method: "GET",
      headers: headers,
    })
      .then(response => {
        if (response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('csrftoken');
          localStorage.removeItem('auth');
          // const history = createHistory({forceRefresh: true})
          window.location.href = '/session-timeout'
        } else {
          return response.json()
        }
      })
      .then(data => {
        this.setState({
          mlData: data,
          actualData: data,
          loader: false
        })
        console.log(this.state.actualData)
      })
      .catch((err) => {
        console.log(err)

      })
  }


  restoreData = (data) => {
    this.setState({
      mlData: data
    })
  }

  sortingFunc = (type, searchValue) => {
    if (type !== 'search') {
      if (this.state.sortingStatus.sortingName === type) {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: !this.state.sortingStatus.defaultDown
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.mlData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.mlData.sort());
          }
        })
      } else {
        this.setState({
          sortingStatus: {
            sortingName: type,
            defaultDown: true
          },
        }, () => {
          if (this.state.sortingStatus.sortingName === type && this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, type, this.state.mlData.sort());
            // Sorting(this.restoreData, type, this.state.actualData);
          } else if (this.state.sortingStatus.sortingName === type && !this.state.sortingStatus.defaultDown) {
            Sorting(this.restoreData, 'reverse', this.state.mlData.sort());
          }
        })
      }
    } else if (type === 'search') {
      type = 'search';
      Sorting(this.restoreData, type, this.state.actualData, searchValue);
    } else {
      type = 'reverse';
      Sorting(this.restoreData, type, this.state.actualData);
    }
  }

  assignedBoxRender = (status) => {
    if (status === 'unassigned') {
      return <div style={{ height: '2.5vh', marginLeft: '19px', width: '3vw', backgroundColor: '#A9A9A9', borderRadius: "2.5vh", }}></div>
    } else if (status === 'Assigned SI') {
      return <div style={{ height: '2.5vh', width: '3vw', marginLeft: '19px', backgroundColor: '#F07E25', borderRadius: "2.5vh", }}></div>
    } else if (status === "Assigned Project") {
      return <div style={{ height: '2.5vh', width: '3vw', marginLeft: '19px', backgroundColor: '#78244C', borderRadius: "2.5vh", }}></div>
    } else if (status === "Assigned Distributor") {
      return <div style={{ height: '2.5vh', width: '3vw', marginLeft: '19px', backgroundColor: '#00b0a9', borderRadius: "2.5vh", }}></div>
    }
  }


  fetchIconType = (e) => {
    if (e === this.state.sortingStatus.sortingName && this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-down pointer ml-2 float-right'
    } else if (e === this.state.sortingStatus.sortingName && !this.state.sortingStatus.defaultDown) {
      return 'fas fa-chevron-up pointer ml-2 float-right'
    } else {
      return 'fas fa-chevron-down pointer ml-2 float-right icon-inactive'
    }
  }

  obDatatable = () => {
    if (this.state.mlData !== null) {
      if (this.state.mlData.length === 0) {
        return <tr style={{ textAlign: 'center' }} >No. available member license</tr>
      }
      let someData = this.state.mlData.map((mlElement, index) => {
        return <tr key={index} className="some-hover">
          <td scope="col" style={{ width: '100px', fontSize:'12px' }} >{mlElement.id}</td>
          <td scope="col" style={{ fontSize:'12px'}} >{mlElement.licenseNo}</td>
          <td scope="col" style={{ width: '120px', fontSize:'12px' }}>{this.assignedBoxRender(mlElement.status)}</td>
          <td style={{ width: '150px', textAlign: 'left' }}>
            {/* <OverlayTrigger
              placement='auto'
              display={false}
              overlay={mlElement.status === 'unassigned' ? <div></div> : <Tooltip id="overlay-example">Assigned</Tooltip>}>
              <span className="d-inline-block">
                <span
                  style={{ pointerEvents: mlElement.status !== 'unassigned' ? 'none' : '', opacity: mlElement.status !== 'unassigned' ? '0.5' : '' }}
                  onClick={(e) => {
                    this.setState({
                      itemToDeleteId: mlElement.id,
                      modalIsOpenDelete: true
                    })
                  }}>
                  <img src={deleteIcon} alt="" style={{ width: '16px', height: '16px', marginLeft: '29px', marginRight: '15px' }} />
                </span>
              </span>
            </OverlayTrigger> */}
            <span className="d-inline-block">
              {(() => {
                const userType = localStorage.getItem("user_type");
                const hasDeletePermission =
                  userType === "1" ||
                  (userType === "2" &&
                    is_allowed(this.props.redux.permissions.permissions, "2", "distributor", "delete"));
                const isAssigned = mlElement.status !== 'unassigned';
                const isDisabled = !hasDeletePermission || isAssigned;

                const tooltipText = isAssigned
                  ? "Assigned"
                  : !hasDeletePermission
                    ? "You don't have permission"
                    : "Delete";

                return (
                  <Tooltip title={tooltipText} arrow>
                    <span
                      style={{
                        pointerEvents: isDisabled ? 'none' : 'auto',
                        opacity: isDisabled ? 0.5 : 1,
                        marginLeft: '29px',
                        marginRight: '15px',
                        display: 'inline-block',
                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                      }}
                      onClick={() => {
                        if (!isDisabled) {
                          this.setState({
                            itemToDeleteId: mlElement.id,
                            modalIsOpenDelete: true
                          });
                        }
                      }}
                    >
                      <img
                        src={deleteIcon}
                        alt="delete"
                        style={{
                          width: '16px',
                          height: '16px',
                          pointerEvents: 'none'
                        }}
                      />
                    </span>
                  </Tooltip>
                );
              })()}
            </span>


          </td>
        </tr>
      })
      return someData;
    } else {
      return <tr>No. Member License Available</tr>
    }
  }


  numberOfLicense = (boxState) => {
    let numberOfLicenseStatus = 0;
    this.state.actualData.forEach((e) => {
      if (e.status === boxState) {
        numberOfLicenseStatus = numberOfLicenseStatus + 1;
      }
    })
    return numberOfLicenseStatus
  }

  siNameHandler = (data, siId) => {
    let siName = 'unassigned';
    data.forEach((element) => {
      if (Number(element.si_id) === Number(siId)) {
        siName = element.si_userName
      }
    })
    return siName
  }


  overlayShadowUnderModal = (type) => {
    if (type === 'overlay') {
      if (this.state.modalIsOpenAddOB || this.state.modalIsOpenAddOBView || this.state.modalIsOpenAddOBEdit) {
        return (
          <div style={{ position: 'absolute', height: `${window.innerHeight - 60}px`, width: `${window.innerWidth - 260}px`, backgroundColor: 'rgba(0,0,0,0.75)', zIndex: '0', display: '' }}></div>
        )
      } else {
        return null
      }
    } else if (type === 'scroll') {
      return 'hidden'
    }
  }


  resetSearchBar = () => {
    this.props.searchBarActivate(false)
  }


  render() {
    return (
      <React.Fragment>
        <SnackBar open={this.state.snackbarActive} handleSnackbarClose={() => {
          this.setState({
            snackbarActive: false
          })
        }} message={this.state.snackbarMessage} />
        {this.state.loader ? <Loader /> : null}
        {this.overlayShadowUnderModal('overlay')}
        <div style={{ paddingLeft: '10px', paddingTop: '40px', paddingRight: '15px', height: `${window.innerHeight - 70}px` }}>
          {!this.props.redux.auth.searchBarShow ? <div style={{ marginBottom: '20px' }}>
            <span style={{ color: '#888888', fontSize: '30px', }}>MEMBER LICENSE</span>
            <span style={{ float: 'right' }}>
              {!this.props.redux.auth.searchBarShow ? <div className="row" style={{ margin: '0' }}>
                <div className="pointer" onClick={this.openModal} >
                  {(
                    localStorage.getItem("user_type") === "1" ||
                    (
                      localStorage.getItem("user_type") === "2" &&
                      is_allowed(this.props.redux.permissions.permissions, localStorage.getItem("user_type"), "member license", "add")
                    )
                  ) && (
                      <div className="buttonContent" style={{ backgroundColor: 'white', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)' }}>
                        {/* <Icon icon={iosPlusEmpty} size={40} style={{ color: "#F08100", backgroundColor: "none", }} /> */}
                        <IconButton sx={{
                          color: '#F08100',
                          fontSize: 40,
                          backgroundColor: 'transparent',
                          '&:hover': {
                            backgroundColor: 'transparent'
                          },
                          '&:focus': {
                            outline: 'none',
                            border: 'none',
                            backgroundColor: 'transparent'
                          }
                        }} aria-label="add">
                          <AddIcon sx={{ fontSize: 40 }} />
                        </IconButton>
                        <span style={{ color: '#888888', fontSize: '10px', fontWeight: '600' }}>ADD NEW MEMBER LICENSE</span>
                      </div>)}
                </div>
              </div> : null}
            </span>
          </div> : <div className='animated animated-duration-custom slideInDown pb-3 mt-2 flex-fill'>
            <SearchBar
              value=''
              onChange={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', this.state.searchValue)
                })
              }
              }
              onRequestSearch={() => this.sortingFunc('search', this.state.searchValue)}
              resetSearch={(e) => {
                this.setState({
                  searchValue: e
                }, () => {
                  this.sortingFunc('search', '')
                })
              }}
            />
          </div>}
          {/* {!this.props.redux.auth.searchBarShow ? <div class="d-flex">
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#A9A9A9', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Unassigned<br />Member License</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '50px', marginTop: '10px', float: 'right', borderRadius: "15px 15px 0px 0px" }} >{this.numberOfLicense('unassigned')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#00b0a9', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />Distributor</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '50px', marginTop: '10px', float: 'right', }} >{this.numberOfLicense('Assigned Project')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#A0A5EB', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />Projects</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '50px', marginTop: '10px', float: 'right', }} >{this.numberOfLicense('Assigned Project')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#F07E25', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />System Integrator</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '50px', marginTop: '10px', float: 'right', }} >{this.numberOfLicense('Assigned SI')}</div>
                </div>
              </div>
            </div> */}

          {!this.props.redux.auth.searchBarShow ? <div class="d-flex">
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#A9A9A9', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Unassigned<br />Member License</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', borderRadius: "15px 15px 0px 0px" }} >{this.numberOfLicense('unassigned')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#00b0a9', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />Distributor</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', }} >{this.numberOfLicense('Assigned Distributor')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill" style={{ marginRight: '50px' }}>
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#78244C', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />Project Manager</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', }} >{this.numberOfLicense('Assigned Project')}</div>
                </div>
              </div>
            </div>
            <div class="flex-fill">
              <div className="custom-card-dashboard" style={{ borderRadius: "15px", backgroundColor: 'white' }}>
                <div style={{ height: '11px', backgroundColor: '#F07E25', borderRadius: "15px 15px 0px 0px" }}></div>
                <div style={{ height: '81px', backgroundColor: 'white', borderRadius: "0px 0px 15px 15px" }}>
                  <div style={{ fontSize: '15px', marginLeft: '20px', marginTop: '20px', float: 'left', width: '126px' }}>Assigned to<br />SystemIntegrator</div>
                  <div style={{ fontSize: '40px', fontWeight: 'bolder', color: '#43425D', marginRight: '10px', marginTop: '10px', float: 'right', }} >{this.numberOfLicense('Assigned SI')}</div>
                </div>
              </div>
            </div>

          </div> : null}
          <table className="table" style={{ marginTop: '30px' }}>
            <thead className="tableHeaderColor" style={{ borderRadius: '10px 10px 0px 0px' }}>
              <th scope="col" style={{ width: '100px', fontSize: '12px' }} >
                ID
                <i class={this.fetchIconType('id')} onClick={(e) => { this.sortingFunc('id') }}>
                </i>
              </th>
              <th scope="col" style={{ fontSize: '12px' }}>
                Member License
                <i class={this.fetchIconType('licenseNo')} onClick={(e) => { this.sortingFunc('licenseNo') }}></i>
              </th>
              <th scope="col" style={{ width: '120px', fontSize: '12px' }}>
                Status
                <i class={this.fetchIconType('status')} onClick={(e) => { this.sortingFunc('status') }}></i>
              </th>
              <th scope="col" style={{ width: '150px', fontSize: '12px' }}>
                Delete
              </th>
            </thead>
            <tbody style={{ maxHeight: this.props.redux.auth.searchBarShow ? `${window.innerHeight - 250}px` : `${window.innerHeight - 400}px`, overflowY: 'overlay' }}>
              {this.obDatatable()}
            </tbody>
          </table>
        </div>
        {this.ActivateMLModel()}
        {this.ActivateObModelView()}
        {this.ActivateObModelEdit()}
        <Modal
          isOpen={this.state.modalIsOpenDelete}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModalDelete}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Are you sure you want to proceed with deletion?</h3>
            <i class="fas  fa-question-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={this.onDeleteFinal.bind(this)}>Delete </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.modalIsOpenDeleteSuccess}
          style={customStylesDelete}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times"
              onClick={() => {
                this.setState({
                  modalIsOpenDeleteSuccess: false
                })
              }}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Member license deleted successfully.</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <div className="btn reset-btn mx-2 px-5" onClick={() => {
              this.setState({
                modalIsOpenDeleteSuccess: false
              })
            }}>Close</div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}


const mapStateToProps = state => {
  return {
    redux: state,
  };
};



const mapDispatchToProps = dispatch => {
  return {
    searchBarActivate: (data) => dispatch({ type: ActionTypes.SEARCHBAR, data: data }),
    searchBarStyleActivate: (data) => dispatch({ type: ActionTypes.SEARCHBARSTYLE, data: data }),

  };
};


export default connect(mapStateToProps, mapDispatchToProps)(MemberLicense);